import { useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import { partnerChecklistApi } from 'helpers';

export const usePartnerChecklist = () => {
  const notify = useNotify();
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [aboutVideo, setAboutVideo] = useState('');
  const [tasks, setTasks] = useState({});

  const dispatch = {};

  dispatch.disableNotification = () => {
    partnerChecklistApi
      .disableNotification()
      .then(res => {})
      .catch(err => {
        notify(err?.response?.data?.message || 'Something went wrong', 'error');
      });
  };

  useEffect(() => {
    setLoading(true);
    partnerChecklistApi
      .getProgress()
      .then(res => {
        const taskList = res.data.products.tasks;
        const { total_done, total_tasks } = taskList;
        const progressVal = ((total_done / total_tasks) * 100).toFixed(0);
        setProgress(+progressVal);
        setAboutVideo(res.data.learn_more.video_url);
        setTasks(taskList);
      })
      .catch(err => {
        notify(err?.response?.data?.message || 'Something went wrong', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [notify]);

  return { loading, progress, aboutVideo, tasks, dispatch };
};
